"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var I18n = require("i18n-js");
var facet_option_1 = require("./facet_option");
var filter_link_1 = require("./filter_link");
var bind_1 = require("../bind");
var SelectFacetOption = /** @class */ (function (_super) {
    tslib_1.__extends(SelectFacetOption, _super);
    function SelectFacetOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SelectFacetOption.prototype, "zeroCount", {
        get: function () {
            return this.props.option.count && this.props.option.count.value === 0;
        },
        enumerable: true,
        configurable: true
    });
    SelectFacetOption.prototype.onLinkClick = function (evt) {
        if (this.zeroCount) {
            evt.preventDefault();
        }
    };
    SelectFacetOption.prototype.linkParams = function () {
        var _a;
        var useUnset = this.props.option.selected && this.props.checkbox;
        var values = useUnset ? this.props.option.unsetValues : this.props.option.setValues;
        return _a = {}, _a[this.props.option.paramName] = values, _a;
    };
    SelectFacetOption.prototype.renderCount = function () {
        if (!this.props.option.count) {
            return null;
        }
        return (React.createElement("div", { className: "facet__option__count" },
            "(",
            I18n.toNumber(this.props.option.count.value, { precision: 0 }),
            ")"));
    };
    SelectFacetOption.prototype.render = function () {
        var option = this.props.option;
        var linkClass = classNames({
            facet__link: true,
            'facet__link--checkbox': this.props.checkbox,
            'facet__link--active': option.selected,
        });
        return (React.createElement(facet_option_1.default, { active: option.selected, childActive: this.props.childActive, disabled: this.zeroCount, paramName: option.paramName },
            React.createElement(filter_link_1.default, { onClick: this.onLinkClick, className: linkClass, params: this.linkParams(), "data-checked": option.selected || null, "data-disabled": this.zeroCount || null, rel: "nofollow" },
                React.createElement("div", null,
                    React.createElement("span", { className: "mr-space" }, option.name),
                    this.renderCount())),
            this.props.children));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SelectFacetOption.prototype, "onLinkClick", null);
    return SelectFacetOption;
}(React.Component));
exports.default = SelectFacetOption;
//# sourceMappingURL=select_facet_option.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/select_facet_option.js
// module id = h8WY
// module chunks = 0 1 2 3 4 9 10 14 20